export default "__VITE_ASSET__BErMOK4v__"